import React from 'react';
import { Helmet } from 'react-helmet-async';
import IntroductionTabs from '../../IntroductionTabs';
import KakaoMapEmbed from './KakaoMapEmbed';

const Location = () => {
  const canonical = 'https://www.xn--o39ap7bo6pk0bo2x.com/intro/location';
  const title = '오시는길 - 주식회사 가까운물류';
  const desc = '주식회사 가까운물류의 위치 및 오시는길을 확인하세요.';

  return (
    <div className="location-page">
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={canonical} />
        <meta name="description" content={desc} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:url" content={canonical} />
        <meta property="og:site_name" content="주식회사 가까운물류" />
        <meta property="og:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={desc} />
        <meta name="twitter:image" content="https://www.xn--o39ap7bo6pk0bo2x.com/og-1200x630.png?v=1" />
      </Helmet>
      {/* IntroductionTabs 컴포넌트 사용 */}
      <IntroductionTabs type="company">
        {/* 오시는길 탭 */}
        <div 
          tabId="location"
          className="location-content-wrapper"
        >
          <KakaoMapEmbed />
        </div>
      </IntroductionTabs>
    </div>
  );
};

export default Location; 